import {
  fetchAllProductsWithCache,
  fetchProductBySlugWithCache,
} from "@/libs/findProductWithCache";
import { Product } from "@/api/product-api";
import { QueryClient } from "@tanstack/react-query";

export const ProductQuery = {
  products: (countryCode: "US" | "KR" = "US") => ({
    queryKey: ["products", countryCode],
    queryFn: () => fetchAllProductsWithCache(countryCode),
  }),
  productBySlug: (slug: string | null, countryCode: "US" | "KR" = "US") => ({
    queryKey: ["product", slug, countryCode],
    queryFn: () => fetchProductBySlugWithCache(slug, countryCode),
  }),
  queryData: {
    product: (
      queryClient: QueryClient,
      slug: string | null,
      countryCode: "US" | "KR" = "US",
    ) => {
      return (
        queryClient.getQueryData<Product>(["product", slug, countryCode]) ??
        null
      );
    },
    products: (queryClient: QueryClient, countryCode: "US" | "KR" = "US") => {
      return (
        queryClient.getQueryData<Product[]>(["products", countryCode]) ?? []
      );
    },
  },
};
